<template>
    <v-data-table
        :headers="headers"
        :items="entities"
        class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('src\\views\\bloggerresources\\list.9537') }}</v-toolbar-title>
                <v-spacer />
                <v-btn v-if="user.adminAccess && user.adminAccess.blogger_resources >= ACCESS.WRITE" color="primary" @click="create">
                    <v-icon>mdi-plus</v-icon>{{ $t('src\\views\\bloggerresources\\list.981') }}</v-btn>
            </v-toolbar>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
            {{ item.createdAt | moment('DD.MM.YYYY HH:mm') }}
        </template>
        <template v-slot:[`item.edit`]="{ item }">
            <v-icon color="primary" @click="edit(item._id)">mdi-pencil</v-icon>
        </template>
        <template v-slot:[`item.remove`]="{ item }">
            <v-icon color="primary" @click="remove(item._id)">mdi-close-octagon-outline</v-icon>
        </template>
    </v-data-table>
</template>

<script>
    import store from '@/store';
    import { mapState } from 'vuex';
    import { BOOKING_STATUS_TITLE } from '@/vars';
    import { ACCESS } from '@/vars';

    export default {
        name: 'BloggerResourcesList',
        components: {
        },
        data: () => ({
            ACCESS,
            BOOKING_STATUS_TITLE,
            headers: [],
        }),
        computed: {
            ...mapState('auth', ['user']),
            ...mapState('bloggerResources', ['entities']),
        },
        async mounted() {
            await store.dispatch('auth/fetch');
            await store.dispatch('bloggerResources/fetch', {});
            this.headers = [
                { text: this.$t('src\\views\\bloggerresources\\list.createdAt'), value: 'createdAt' },
                { text: this.$t('src\\views\\bloggerresources\\list.title'), value: 'title' },
                { text: this.$t('src\\views\\bloggerresources\\list.file'), value: 'file' },
            ]
            if(this.user && this.user.adminAccess && this.user.adminAccess.blogger_resources >= ACCESS.WRITE) {
                this.headers.push({ text: this.$t('src\\views\\bloggerresources\\list.edit'), align: 'right', value: 'edit' })
                this.headers.push({ text: this.$t('src\\views\\bloggerresources\\list.remove'), align: 'right', value: 'remove' })
            }
        },
        methods: {
            async create() {
                await this.$router.push({ name: 'blogger-resources-create' });
            },
            async edit(id) {
                await this.$router.push({ name: 'blogger-resources-edit', params: { id } });
            },
            async remove(id) {
                await store.dispatch('bloggerResources/delete', { id });
                await store.dispatch('bloggerResources/fetch', {});
            }
        }
    }
</script>
